import localeText from "../../../../locale";
import "./AdminVersionSwitch.css";

// Botão flutuante exibido sobre o admin clássico, para não precisar alterar o AdminBackoffice
const AdminVersionSwitch = ({ onClick }) => (
  <button type="button" className="admin-version-switch" onClick={onClick}>
    <i className="pi pi-star" aria-hidden="true" />
    <span>{localeText("adminPanelTryNew")}</span>
  </button>
);

export default AdminVersionSwitch;
